module.exports = __webpack_public_path__ + "img/breast-cancer-leaflet.a953fb65.jpg";